import { useEffect, useState } from 'react';
import FileData from '../Models/FileData';
import LinkData from '../Models/LinkData';
import fileService from '../Services/fileService';
import linkService from '../Services/linkService';
import FileContainer from '../components/Content/FileContainer';
import LinkContainer from '../components/Content/LinkContainer';
import '../css/HomePage.css';

export default function HomePage() {
	const [files, setFiles] = useState([new FileData()].filter((x) => false));
	const [links, setLinks] = useState([new LinkData()].filter((x) => false));

	useEffect(() => {
		fileService
			.GetRecent() /*No loading*/
			.then((files) => {
				setFiles(files);
			});

		linkService
			.GetRecent() /*No loading*/
			.then((links) => {
				setLinks(links);
			});
	}, []);

	return (
		<div className='home-container'>
			<div className='ms-3'>
				<div className='home-label'>Főoldal</div>
				<span>
					Köszöntelek Kedves Látogató!
					<br />
					<br />
					Az oldalon Környezetismeret tanításához találsz:
					<br />
					<ul className='ms-3'>
						<li>Tankocka linkeket</li>
						<li>Szerkeszthető feladatlapokat</li>
						<li>Szerkeszthető dolgozatokat</li>
						<li>Egyéb hasznos tartalmakat</li>
					</ul>
					<br />
					Jó böngészést, keresgélést kívánok!
					<br />
					<i>Kirschné Bódi Judit</i>
				</span>
			</div>
			<div className='vertical-list'>
				{links && links.length > 0 ? (
					<>
						<div>Legújabb linkek:</div>
						<div className='overflow-hidden'>
							{links.map((link, index) => (
								<LinkContainer
									link={link}
									showDelete={false}
									key={'link' + index}
									className='float-right'
								/>
							))}
						</div>
					</>
				) : null}
				{files && files.length > 0 ? (
					<>
						<div>Legújabb fájlok:</div>
						<div className='overflow-hidden'>
							{files.map((file, index) => (
								<FileContainer
									file={file}
									showDelete={false}
									key={'file' + index}
									className='float-right'
								/>
							))}
						</div>
					</>
				) : null}
			</div>
		</div>
	);
}
